/**
 * Automatic Ad Refresh Module
 * Handles automatically refreshing ad slots on a defined time interval when the capability is enabled on a particular slot
 * version 2.0.3
 * 
 * Using Semantic Versioning, please update accordingly to keep files in sync across code bases
 * 
 * Given a version number MAJOR.MINOR.PATCH, increment the:
 *  1. MAJOR version when you implement a full re-build of the architecture,
 *  2. MINOR version when you add functionality, and
 *  3. PATCH version when you implement bug fixes or make small  tweaks to current functionality.
 */
define('AdModules/autorefresh',[
    "jquery",
    "underscore",
    "logging",
    "utilities",
    "AdPlatforms/dfp",
    "AdModules/headerbidding"
], function ($, _, logging, utilities, dfp, headerbidding) {
    "use strict";

    var _ModuleName = "DFP Auto Refresh Module";

    var _config = {}
    var _data = {
        slots: []
    }

    /**
     * Get configuration data off config object
     * @param {Config} config Configuration object
     */
    var init = function (config) {
        $.extend(_config, config.autorefresh);
    }

    /*
     * Configures auto refresh for all the slots that have been loaded
     */
    var start = function () {
        if (!dfp) { logging.error("DFP not loaded in start, this isn't going to end well", _ModuleName); }

        if (_config.enabled) {
            ;
            _adSlotCleanup();

            ;
            var throttled = _.throttle(_handleAutoRefreshScroll, _config.throttle);
            $(window).scroll(throttled);
        } else {
            ;
        }
    }

    /**
     * Registers a single ad slot for automatic refresh
     * @param {AdSlot} slot Ad slot object
     */
    var registerSlot = function (slot) {
        if (slot && slot.autorefresh) {
            ;
            _data.slots.push(slot);
        }
    }

    /**
     * Register several ad slots to be automatically refreshed
     * @param {Array<AdSlot>} slots An array of ad slot objects to be registered
     */
    var registerSlots = function (slots) {
        for (var i = 0; i < slots.length; i++) {
            registerSlot(slots[i]);
        }
    }

    var _adSlotCleanup = function() {
        for (var i = 0; i < _data.slots.length; i++) {
            var slot = _data.slots[i];

            // Disable auto refresh on road block
            if (slot.isRoadBlock) {
                ;
                _data.slots.splice(i, 1); // remove element from the array
                i--; // reduce indexer since we've removed an element from the array
            }
        }
    }

    /**
     * Handle the refresh of a given slot when  timer is up
     * @param {AdSlot} slot Ad slot object
     */
    var _handleAutoRefresh = function (slot) {
        slot.autorefreshstate = _config.state.READY;

        if (slot.loaded && utilities.elementIsInView(slot.dom) && document.hasFocus()) {
            _refreshAd(slot);
        } else {
            ;
        }
    }

    /*
     * Handle view detection on scroll so slots are only refreshed if they are in view
     */
    var scrolllock = false;
    var _handleAutoRefreshScroll = function () {
        if (scrolllock) return;

        scrolllock = true;
        for (var i = 0; i < _data.slots.length; i++) {
            var slot = _data.slots[i];

            // Changes only occur when an ad slot is in view and loaded
            if (!slot.loaded || !utilities.elementIsInView(slot.dom)) continue;

            switch (slot.autorefreshstate) {
                case _config.state.IDLE:
                    // Set timeout for refresh
                    setTimeout(_handleAutoRefresh, _config.timeout * 1000, slot);

                    // Timeout is set, set state to WAIT
                    slot.autorefreshstate = _config.state.WAIT;

                    ;
                    break;

                case _config.state.READY:
                    // Slot is ready for a refresh now
                    _refreshAd(slot);
                    break;
            }
        }
        scrolllock = false;
    }

    /**
     * Handle the actual refresh of a slot 
     * @param {AdSlot} slot Ad slot object
     */
    var _refreshautocount = 0;
    var _refreshAd = function (slot) {
        // only refresh an ad in the READY state
        if (slot.autorefreshstate != _config.state.READY) {
            logging.warn("A call was made to refresh an ad that was no in a READY state", _ModuleName);
            return;
        };

        ;

        // Mark slot as refreshing
        slot.autorefreshstate = _config.state.REFRESHING;

        // Create Ready Monitor for DFP Refresh
        var readyMonitorName = 'dfpautorefresh' + (++_refreshautocount);
        utilities.registerReadyMonitor(readyMonitorName, function () {
            ;

            // Call Refresh
            dfp.refreshSlot(slot);

            ;

            // Set timeout for another refresh
            setTimeout(_handleAutoRefresh, _config.timeout * 1000, slot);

            // Timeout is set, set state to WAIT
            slot.autorefreshstate = _config.state.WAIT;
        });

        headerbidding.refresh(slot, readyMonitorName);
    }

    return {
        init: init,
        start: start,
        registerSlot: registerSlot,
        registerSlots: registerSlots,
        enabled: (function () { return _config.enabled; })
    }
});
